module.exports = __webpack_public_path__ + "static/media/no-data.8ca4d184.png";